<div>
  <ion-grid class="ion-no-margin">
    <ion-row>
      <ion-col class="ion-text-start" size="12">
        <ion-icon class="icon-back" name="chevron-back" (click)="emitGoBackEvent()"/>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="10" class="title-container">
        @if (positionOverview$ | async; as positionOverview) {
          <div class="currency-item">{{ positionOverview?.symbol }}</div>
          <div class="trades-item">
            <span class="trades-number">{{ positionOverview?.tradesCount }}</span>
            <span>{{ 'insights.labels.trades' | translate }}</span>
          </div>
        }
      </ion-col>
      <ion-col size="2" class="ion-text-end">
        <ion-icon src="assets/icon/icon_filter.svg"
          class="icon-filter"
          (click)="openFilters()"/>
      </ion-col>
    </ion-row>
    @if (filterPeriods$ | async; as filterPeriods) {
      <ion-row>
        @if (isDefined(filterPeriods.settlementPeriod) && positionOverview?.tradesCount > 0) {
          <app-tenor-bar class="tenor-bar"
                         [availableTenors]="availableTenors"
                         [activeTenor]="activeTenor"
                         (changeActiveTenor)="onTenorSelect($event)" />
        }
      </ion-row>
    }
    <ion-row class="subtitle">
      @if (netAmounts) {
        <span class="subtitle">{{ 'insights.subtitle-net-amounts' | translate }}</span>
      }
      @if (totalAmounts) {
        <span class="subtitle">{{ 'insights.subtitle-total-amounts' | translate }}</span>
      }
    </ion-row>
    @if (isChartEmpty) {
      <div class="empty-chart-wrap">
        <ion-icon src="assets/icon/empty_chart.svg" class="empty_chart"/>
      </div>
    }
    <ion-row>
      @if (isChartEmpty) {
        <div class="ion-text-center" style="margin: 50px auto">
          <ion-label class="no-trades">{{ 'insights.no-trades-shown' | translate }}</ion-label>
        </div>
      }
      <ion-col size="12">
        <section class="chart-wrapper">
          <div #barChart></div>
        </section>
      </ion-col>
    </ion-row>
  </ion-grid>
  @if (!isChartEmpty) {
    @if (filterPeriods$ | async; as filterPeriods) {
      <app-insights-dates-label [backgroundGrey]="true"
                                [positionOverviewFilter]="positionOverviewFilter"
                                [filterPeriods]="filterPeriods" />
    }
    @if (isDefined(tradingCcy) && isDefined(contraCcy)) {
      <ion-list class="legend-list">
        <app-bar-chart-total-card [positionOverview]="positionOverview"
                                  [viewType]="viewType" />
        <app-bar-chart-side-card [tradingCurrency]="tradingCurrencyBuy"
                                 [contraCurrency]="contraCurrencySell"
                                 [averageRate]="tradingCurrencyRate"
                                 [viewType]="viewType" />
        <app-bar-chart-side-card [tradingCurrency]="tradingCurrencySell"
                                 [contraCurrency]="contraCurrencyBuy"
                                 [averageRate]="contraCurrencyRate"
                                 [viewType]="viewType" />
      </ion-list>
    }
  }
</div>
